import React from 'react';
import IconProps from '../../icons';

const Youtube = ({ width = 24, color = 'var(--text-primary)', className = '' }: IconProps): JSX.Element => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.7466 4.83413C23.119 5.20889 23.3864 5.67489 23.5221 6.18547C24.0239 8.07002 24.0239 12 24.0239 12C24.0239 12 24.0239 15.93 23.5221 17.8146C23.3864 18.3251 23.119 18.7911 22.7466 19.1659C22.3743 19.5407 21.91 19.8111 21.4003 19.95C19.5239 20.4546 12.0239 20.4546 12.0239 20.4546C12.0239 20.4546 4.52393 20.4546 2.64756 19.95C2.13786 19.8111 1.67358 19.5407 1.30121 19.1659C0.928842 18.7911 0.661431 18.3251 0.525744 17.8146C0.0239258 15.93 0.0239258 12 0.0239258 12C0.0239258 12 0.0239258 8.07002 0.525744 6.18547C0.661431 5.67489 0.928842 5.20889 1.30121 4.83413C1.67358 4.45936 2.13786 4.18897 2.64756 4.05002C4.52393 3.54547 12.0239 3.54547 12.0239 3.54547C12.0239 3.54547 19.5239 3.54547 21.4003 4.05002C21.91 4.18897 22.3743 4.45936 22.7466 4.83413ZM15.8421 12L9.56934 8.4314V15.5687L15.8421 12Z'
        fill={color}
      />
    </svg>
  );
};

export default Youtube;
